export const DEFAULT_TICKET_CONTACT_CONTENT = `＜連絡先情報＞
（住所・物件名・号室：　）（入電者名：　）（賃借人との関係性確認：　）
―――――――――――――――――――――――――



―――――――――――――――――――――――――
＜対応補足事項＞
■

＜案内事項＞
■（設備不具合時）現地訪問時に不具合が確認できない場合や入居者故意過失時の費用負担の可能性案内：了承　or　不承　
■（設備不具合時）業者等への情報開示許可：了承　or　不承　

＜連絡者の温度感＞
■普通　or　やや高い　or　高い`

export const DEFAULT_CONTRACTOR_NOTE = `メール：
FAX：
上記以外の連絡先電話番号：
営業時間：
定休日：
その他：`
